import React from 'react';
import { Globe, Phone, Mail } from 'react-feather';
import styles from './ContactStrip.module.scss';

interface IProps {
  className?: string;
  contact?: string;
  email?: string;
  website?: string;
}

const ContactStrip = ({ className, contact, email, website }: IProps) => {
  return (
    <div className={classnames(styles.contact, className)}>
      {website && (
        <a
          id="ContactStrip_WebsiteBtn"
          className={styles.contactBtn}
          href={`https://${website}`}
          target="_blank"
        >
          <Globe />
        </a>
      )}
      {contact && (
        <a
          id="ContactStrip_ContactBtn"
          className={styles.contactBtn}
          href={`tel:${contact}`}
        >
          <Phone />
        </a>
      )}
      {email && (
        <a
          id="ContactStrip_EmailBtn"
          className={styles.contactBtn}
          href={`mailto:${email}`}
        >
          <Mail />
        </a>
      )}
    </div>
  );
};

export default ContactStrip;
